<template>
    <div class="missing-page">
        <div class="parallax-wrapper" data-parallax='{"y": 250, "smoothness": 10}'>
            <wp-image :image="backgroundImage"
                      :is-background="true"
                      size-sd="rectangle-sd"
                      :load-immediate="true"
                      @loaded="loadPage"
                      class="contact-background">
                <div v-if="applyOverlay"
                     class="overlay"
                     :style="`background-color: ${overlay};`">
                </div>
            </wp-image>
        </div>
        <div  v-if="content" class="content-container" v-scroll-reveal="{delay: 500}">
            <content-block v-bind="content" />
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../utils/EventBus'
    import ContentBlock from '../modules/components/ContentBlock'

    export default {
        name: "Page404",
        components: { ContentBlock },
        data() {
            return {
                settings: wp.settings.settings404
            }
        },
        computed: {
            isMobile() {
                return EventBus.isMobile
            },
            background() {
                return this.settings.background_image
            },
            mobileBackground() {
                return this.settings.mobile_background_image
            },
            backgroundImage() {
                return this.isMobile && this.mobileBackground ? this.mobileBackground : this.background
            },
            applyOverlay() {
                return this.settings.apply_background_overlay
            },
            overlay() {
                return this.settings.background_overlay
            },
            content() {
                return this.settings.content
            },
        },
        methods: {
            loadPage() {
                this.$emit('pageLoaded');
                EventBus.setPageLoaded(true);
                this.$scrollTo('body', 100, {offset: 1});
            }
        }
    }
</script>

<style lang="scss" scoped>

    .missing-page {
        height: 101vh;
        min-height: 700px;
        position: relative;
        overflow: hidden;
        margin-bottom: 10px;
        padding: 150px 0;
        font-size: 18px;
        line-height: 30px;
        display: flex;
        align-items: center;

        @media (min-width: $site-container-width) {
            min-height: 1300px;
        }
    }

    .parallax-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: -22;
    }

    .overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .contact-background {
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .content-container {
        margin: 0 auto;
        width: 90%;
        background-color: white;
        display: flex;
        flex-direction: column;
        padding: 60px 30px;

        @media (min-width: $bp-small) {
            position: absolute;
            left: 80px;
            width: 60%;
            padding: 60px;
        }

        @media (min-width: $bp-medium) {
            width: 50%;
        }

        @media (min-width: $bp-desktop) {
            width: 43%;
        }

        @media (min-width: $site-container-width) {
            padding: 75px;
        }

        /deep/ .content-block, 
        /deep/ .content-block > .block {
            padding: 0;
        }

        // a {
        //     text-decoration: none;
        //     color: #000;
        //     &:hover {
        //         cursor: pointer;
        //         color: $theme-orange;
        //     }
        // }
    }

</style>